import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useState } from "react";
import { CurrentUserPartyBankAccountsDocument, useCurrentUserPartyBankAccountsQuery, useDeletePartyBankAccountMutation, } from "generated/generated-models";
import { Loading } from "app/lib/components/Loading";
import { CError } from "app/common/CError";
import { makeNonEmpty } from "core/util/array";
import { useScreenSize } from "app/lib/useScreenSize";
import AddPayAnyone from "./AddPayAnyone";
import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemText, Paper, Stack, Typography, styled, useMediaQuery, } from "@mui/material";
import { DataGridPro, GridLogicOperator, } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { LoadingButton } from "@mui/lab";
import NoRowsOverlay from "app/components/NoRowsOverlay";
const BankAccountRow = ({ pba, deletePartyBankAccount }) => {
    return (_jsx(IconButton, { "aria-label": "delete", id: "deletePartyBankAccount", onClick: () => deletePartyBankAccount(pba), children: _jsx(DeleteIcon, {}) }));
};
const ManagePayAnyoneAccountsView = ({ bankAccounts, deletePartyBankAccount, }) => {
    const [open, setOpen] = React.useState(false);
    const screenSize = useScreenSize();
    const fullScreen = useMediaQuery("(max-width: 768px)");
    bankAccounts.sort((a, b) => 
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    a.BankAccount?.AccountName.toUpperCase() >
        // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
        b.BankAccount?.AccountName.toUpperCase()
        ? 1
        : -1);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rows = bankAccounts.map((item) => item);
    const columns = [
        {
            field: "AccountName",
            headerName: "Name",
            minWidth: 300,
            flex: 3,
            renderCell: (params) => params.row.BankAccount.AccountName,
        },
        {
            field: "BankIdentifierText",
            headerName: "BSB",
            minWidth: 150,
            flex: 2,
            renderCell: (params) => params.row.BankAccount.BankIdentifierText,
        },
        {
            field: "AccountNumber",
            headerName: "Account No.",
            minWidth: 150,
            flex: 2,
            renderCell: (params) => params.row.BankAccount.AccountNumber,
        },
        {
            field: " ",
            headerName: "",
            minWidth: 20,
            flex: 1,
            align: "center",
            renderCell: (params) => (_jsx(BankAccountRow, { pba: params.row, deletePartyBankAccount: deletePartyBankAccount })),
        },
    ];
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: "center",
        color: theme.palette.text.secondary,
    }));
    const handleAddPayAnyoneClick = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (_jsxs("div", { className: "biller-container", style: { height: 650, width: "100%" }, children: [_jsxs(Box, { className: "tab-header", sx: { mb: 2 }, children: [_jsx(Typography, { variant: "h6", component: "h6", sx: { mx: 1, my: 0 }, children: "Pay Anyone Accounts" }), _jsx(Button, { startIcon: _jsx(GroupAddIcon, {}), onClick: handleAddPayAnyoneClick, id: "addPayAnyoneButton", children: "Add Pay Anyone" })] }), screenSize === "desktop" ? (_jsx(DataGridPro, { className: "payees-grid", columns: columns, rows: rows, getRowId: (r) => r.Id, pagination: true, pageSizeOptions: [10, 25, 50], initialState: {
                    sorting: {
                        sortModel: [{ field: "AccountName", sort: "asc" }],
                    },
                    pagination: {
                        paginationModel: { pageSize: 10 },
                    },
                }, slots: {
                    noRowsOverlay: () => (_jsx(NoRowsOverlay, { children: "You have no saved pay anyone bank accounts." })),
                }, disableColumnSelector: true, slotProps: {
                    filterPanel: {
                        logicOperators: [GridLogicOperator.And],
                        columnsSort: "asc",
                        filterFormProps: {
                            logicOperatorInputProps: {
                                variant: "outlined",
                                size: "small",
                            },
                            columnInputProps: {
                                variant: "outlined",
                                size: "small",
                                sx: { mt: "auto" },
                            },
                            operatorInputProps: {
                                variant: "outlined",
                                size: "small",
                                sx: { mt: "auto" },
                            },
                            deleteIconProps: {
                                sx: {
                                    "& .MuiSvgIcon-root": {
                                        color: "#d32f2f",
                                    },
                                },
                            },
                        },
                        sx: {
                            "& .MuiDataGrid-filterForm": { p: 2 },
                            "& .MuiDataGrid-filterForm:nth-child(even)": {
                                backgroundColor: (theme) => theme.palette.mode === "dark"
                                    ? "#444"
                                    : "#f5f5f5",
                            },
                            "& .MuiDataGrid-filterFormLinkOperatorInput": {
                                mr: 2,
                            },
                            "& .MuiDataGrid-filterFormColumnInput": {
                                mr: 2,
                                width: 150,
                            },
                            "& .MuiDataGrid-filterFormOperatorInput": {
                                mr: 2,
                            },
                            "& .MuiDataGrid-filterFormValueInput": {
                                width: 200,
                            },
                        },
                    },
                } })) : (_jsx(Stack, { spacing: 2, children: bankAccounts.map((account) => {
                    return (_jsx(Item, { sx: { pb: 1.5 }, children: _jsxs(List, { className: "payees-list-mobile", children: [_jsx(ListItem, { disablePadding: true, className: "delete-item", children: _jsx(ListItemText, { primary: _jsx(Typography, { children: _jsx(IconButton, { "aria-label": "delete", id: "deletePartyBankAccountButton", children: _jsx(ClearIcon, { onClick: () => deletePartyBankAccount(account) }) }) }) }) }), _jsx(ListItem, { disablePadding: true, sx: { px: 3 }, children: _jsx(ListItemText, { primary: _jsx(Typography, { children: _jsx("span", { className: "subtitle", children: account.BankAccount
                                                    ?.AccountName }) }) }) }), _jsx(ListItem, { disablePadding: true, sx: { px: 3 }, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsxs("span", { className: "subtitle", children: ["BSB:", " "] }), " ", account.BankAccount
                                                    ?.BankIdentifierText] }) }) }), _jsx(ListItem, { disablePadding: true, sx: { px: 3 }, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsxs("span", { className: "subtitle", children: ["Account No:", " "] }), " ", account.BankAccount
                                                    ?.AccountNumber] }) }) })] }) }, account.Id));
                }) })), _jsx(Dialog, { fullScreen: fullScreen, className: "add-payee", open: open, onClose: handleClose, fullWidth: true, children: _jsx(DialogContent, { sx: { m: 4 }, children: _jsx(DialogContent, { children: _jsx(AddPayAnyone, { handleClose: handleClose }) }) }) })] }));
};
const ManagePayAnyoneAccounts = () => {
    const [partyBankAccountToBeDeleted, setPartyBankAccountToBeDeleted] = useState(undefined);
    const [deletePartyBankAccountMutation, { loading: deletePbaLoading, error: deletePbaError },] = useDeletePartyBankAccountMutation();
    const fullScreen = useMediaQuery("(max-width: 768px)");
    const deletePartyBankAccount = () => {
        deletePartyBankAccountMutation({
            variables: {
                input: { PartyBankAccountId: partyBankAccountToBeDeleted?.Id },
            },
            refetchQueries: [{ query: CurrentUserPartyBankAccountsDocument }],
        }).then(() => setPartyBankAccountToBeDeleted(undefined));
    };
    const { data, loading, error } = useCurrentUserPartyBankAccountsQuery();
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error) {
        return _jsx(CError, { error: "Could not load bank accounts." });
    }
    if (partyBankAccountToBeDeleted) {
        return (_jsxs(Dialog, { fullScreen: fullScreen, className: "delete-payment-account", open: true, children: [_jsxs(DialogTitle, { children: [_jsx(DeleteIcon, {}), _jsx(Typography, { variant: "h5", gutterBottom: true, component: "h5", sx: { mx: 2, my: 2 }, children: "Delete Account?" })] }), _jsxs(DialogContent, { sx: { m: 4, mt: 0 }, children: [_jsx(Typography, { variant: "body1", gutterBottom: true, component: "p", sx: { textAlign: "center" }, children: "Are you sure you would like to delete this Pay Anyone account?" }), _jsxs(List, { sx: { mb: 2 }, children: [_jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsx(Typography, { children: _jsx("span", { className: "subtitle", children: partyBankAccountToBeDeleted
                                                    .BankAccount?.AccountName }) }) }) }), _jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsx("span", { className: "subtitle", children: "BSB: " }), " ", partyBankAccountToBeDeleted
                                                    .BankAccount?.BankIdentifierText] }) }) }), _jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsxs("span", { className: "subtitle", children: ["Account No:", " "] }), " ", partyBankAccountToBeDeleted
                                                    .BankAccount?.AccountNumber] }) }) })] }), partyBankAccountToBeDeleted.BankAccount
                            ?.HasPendingTransfer === true && (_jsx(Alert, { severity: "warning", children: "There are Upcoming Transfers against these details. They will continue to be processed as usual unless cancelled manually." })), _jsxs("div", { className: "button-row", children: [_jsx(Button, { className: "btn-cancel", id: "cancel", sx: { p: 1.5, mt: 1 }, variant: "contained", onClick: () => setPartyBankAccountToBeDeleted(undefined), children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: { p: 1.5, mt: 1 }, onClick: deletePartyBankAccount, loading: deletePbaLoading, loadingPosition: "end", variant: "contained", children: "Confirm" })] })] })] }));
    }
    return (_jsxs(Fragment, { children: [deletePbaError && (_jsx(CError, { error: "Could not remove bank accounts." })), _jsx(ManagePayAnyoneAccountsView, { bankAccounts: makeNonEmpty(data?.userSession?.Party?.PartyBankAccounts).filter((x) => !x.Deleted && x.PayAnyone), deletePartyBankAccount: setPartyBankAccountToBeDeleted })] }));
};
export { ManagePayAnyoneAccounts };
